<div class="rd-widget rd-widget-no-height-restriction sales-approach-valuation-widget widget-{{widgetConfig.widgetId}}" *ngIf="widgetData">
  <table class="widget-large cellspacing-0 cellpadding-0" aria-hidden="true">
    <thead>
      <dynamic-growth-row [row]="1" [widget]="this">
        <tr class="widget-ruller-flex">
          <th scope="col" colspan="30" class="widget-grid-column sales-approach-valuation-widget-header-red" style="text-align: start;">
            <widget-value class="sales-approach-valuation-widget-header" [align]="'left'" [color]="'white'" [bold]="true">Sales Approach Valuation</widget-value>
          </th>
        </tr>
      </dynamic-growth-row>
      <dynamic-growth-row [row]="2" [widget]="this">
        <tr>
          <th scope="col" colspan="14" class="darkGreyTableHeader align-left"><label class="header-label">Premise</label></th>
          <th scope="col" colspan="8" class="darkGreyTableHeader align-right"><label class="header-label">Value</label></th>
          <th scope="col" colspan="8" class="darkGreyTableHeader align-right"><label class="header-label">Value</label></th>
        </tr>
      </dynamic-growth-row>
    </thead>
    <tbody>
      <dynamic-growth-row [row]="3" [widget]="this">
        <tr class="light-grey-line">
          <td colspan="14"><widget-value [align]="'left'"><label>{{ widgetData.uponStabilizationOrAsIsLabel }}</label></widget-value></td>
          <td colspan="8"><widget-value [align]="'right'"><label>{{ widgetData.uponStabilizationOrAsIsValueFromProjection1 | rdLocalizedDate }}</label></widget-value></td>
          <td colspan="8"><widget-value [align]="'right'"><label>{{ widgetData.uponStabilizationOrAsIsValueFromProjection2 | rdLocalizedDate }}</label></widget-value></td>
        </tr>
      </dynamic-growth-row>
      <dynamic-growth-row [row]="4" [widget]="this">
        <tr>
          <td colspan="14"><label>Indicated Value per Rentable Area</label></td>
          <td colspan="8"><widget-value [align]="'right'"><label>{{currency}}{{ widgetData.uponStabilizationOrAsIsIndicatedValuePerRentableAreaFromProjection1 | rdLocalizedNumber:0 }}</label></widget-value></td>
          <td colspan="8"><widget-value [align]="'right'"><label>{{currency}}{{ widgetData.uponStabilizationOrAsIsIndicatedValuePerRentableAreaFromProjection2 | rdLocalizedNumber:0 }}</label></widget-value></td>
        </tr>
      </dynamic-growth-row>
      <dynamic-growth-row [row]="5" [widget]="this">
        <tr class="light-grey-line">
          <td colspan="14"><label>Subject Rentable Area</label></td>
          <td colspan="8"><widget-value [align]="'right'"><label>{{currency}}{{ widgetData.uponStabilizationOrAsIsSubjectRentableAreaValueFromProjection1 | rdLocalizedNumber:0 }}</label></widget-value></td>
          <td colspan="8"><widget-value [align]="'right'"><label>{{currency}}{{ widgetData.uponStabilizationOrAsIsSubjectRentableAreaValueFromProjection2 | rdLocalizedNumber:0 }}</label></widget-value></td>
        </tr>
      </dynamic-growth-row>
      <dynamic-growth-row [row]="6" [widget]="this">
        <tr>
          <td colspan="14"><label>Indicated Stabilized Value</label></td>
          <td colspan="8"><widget-value [align]="'right'"><label>{{currency}}{{ widgetData.uponStabilizationOrAsIsIndicatedStabilizedValueFromProjection1 | rdLocalizedNumber:0 }}</label></widget-value></td>
          <td colspan="8"><widget-value [align]="'right'"><label>{{currency}}{{ widgetData.uponStabilizationOrAsIsIndicatedStabilizedValueFromProjection2 | rdLocalizedNumber:0 }}</label></widget-value></td>
        </tr>
      </dynamic-growth-row>

      <ng-template *ngTemplateOutlet="adjustmentsTemplate; context: {area: 'uponStabilizationOrAsIs', rowindex: 7}"></ng-template>

      <dynamic-growth-row [row]="12" [widget]="this">
        <tr>
          <td colspan="14"><label>Total Adjustments</label></td>
          <td colspan="8"><widget-value [align]="'right'"><label>{{currency}}{{ widgetData.uponStabilizationOrAsIsTotalAdjustmentsValueFromProjection1 | rdLocalizedNumber:0 }}</label></widget-value></td>
          <td colspan="8"><widget-value [align]="'right'"><label>{{currency}}{{ widgetData.uponStabilizationOrAsIsTotalAdjustmentsValueFromProjection2 | rdLocalizedNumber:0 }}</label></widget-value></td>
        </tr>
      </dynamic-growth-row>
      <dynamic-growth-row [row]="13" [widget]="this">
        <tr class="light-grey-line">
          <td colspan="14"><label>Indicated Value upon Stabilization</label></td>
          <td colspan="8"><widget-value [align]="'right'"><label>{{currency}}{{ widgetData.uponStabilizationOrAsIsIndicatedValueUponStabilizationValueFromProjection1 | rdLocalizedNumber:0 }}</label></widget-value></td>
          <td colspan="8"><widget-value [align]="'right'"><label>{{currency}}{{ widgetData.uponStabilizationOrAsIsIndicatedValueUponStabilizationValueFromProjection2 | rdLocalizedNumber:0 }}</label></widget-value></td>
        </tr>
      </dynamic-growth-row>
      <dynamic-growth-row [row]="14" [widget]="this">
        <tr class="darkGreyTableHeader">
          <td colspan="14"><label style="color: white;">Rounded Value upon Stabilization</label></td>
          <td colspan="8"><widget-value [align]="'right'" [color]="'white'"><label>{{currency}}{{ widgetData.uponStabilizationOrAsIsRoundedValueUponStabilizationValueFromProjection1 | rdLocalizedNumber:0 }}</label></widget-value></td>
          <td colspan="8"><widget-value [align]="'right'" [color]="'white'"><label>{{currency}}{{ widgetData.uponStabilizationOrAsIsRoundedValueUponStabilizationValueFromProjection2 | rdLocalizedNumber:0 }}</label></widget-value></td>
        </tr>
      </dynamic-growth-row>
    </tbody>

    <tbody>
      <dynamic-growth-row [row]="15" [widget]="this">
        <tr class="light-grey-line">
          <td colspan="14"><label>Upon Completion</label></td>
          <td colspan="8"><widget-value [align]="'right'"><label>{{ widgetData.uponCompletitionUponCompletitionValueFromProjection1 | rdLocalizedDate }}</label></widget-value></td>
          <td colspan="8"><widget-value [align]="'right'"><label>{{ widgetData.uponCompletitionUponCompletitionValueFromProjection2 | rdLocalizedDate }}</label></widget-value></td>
        </tr>
      </dynamic-growth-row>
      <dynamic-growth-row [row]="16" [widget]="this">
        <tr>
          <td colspan="14"><label>Indicated Stabilized Value</label></td>
          <td colspan="8"><widget-value [align]="'right'"><label>{{currency}}{{ widgetData.uponCompletitionIndicatedStabilizedValueValueFromProjection1 | rdLocalizedNumber:0 }}</label></widget-value></td>
          <td colspan="8"><widget-value [align]="'right'"><label>{{currency}}{{ widgetData.uponCompletitionIndicatedStabilizedValueValueFromProjection2 | rdLocalizedNumber:0 }}</label></widget-value></td>
        </tr>
      </dynamic-growth-row>
      <ng-template *ngTemplateOutlet="adjustmentsTemplate; context: {area: 'uponCompletition', rowindex: 17}"></ng-template>

      <dynamic-growth-row [row]="22" [widget]="this">
        <tr>
          <td colspan="14"><label>Total Adjustments</label></td>
          <td colspan="8"><widget-value [align]="'right'"><label>{{currency}}{{ widgetData.uponCompletitionTotalAdjustmentsValueFromProjection1 | rdLocalizedNumber:0 }}</label></widget-value></td>
          <td colspan="8"><widget-value [align]="'right'"><label>{{currency}}{{ widgetData.uponCompletitionTotalAdjustmentsValueFromProjection2 | rdLocalizedNumber:0 }}</label></widget-value></td>
        </tr>
      </dynamic-growth-row>

      <dynamic-growth-row [row]="23" [widget]="this">
        <tr class="light-grey-line">
          <td colspan="14"><label>Indicated Value upon Stabilization</label></td>
          <td colspan="8"><widget-value [align]="'right'"><label>{{currency}}{{ widgetData.uponCompletitionIndicatedValueUponCompletionValueFromProjection1 | rdLocalizedNumber:0 }}</label></widget-value></td>
          <td colspan="8"><widget-value [align]="'right'"><label>{{currency}}{{ widgetData.uponCompletitionIndicatedValueUponCompletionValueFromProjection2 | rdLocalizedNumber:0 }}</label></widget-value></td>
        </tr>
      </dynamic-growth-row>

      <dynamic-growth-row [row]="24" [widget]="this">
        <tr class="darkGreyTableHeader">
          <td colspan="14"><label style="color: white;">Rounded Value upon Stabilization</label></td>
          <td colspan="8"><widget-value [align]="'right'" [color]="'white'"><label>{{currency}}{{ widgetData.uponCompletitionRoundedValueUponCompletionValueFromProjection1 | rdLocalizedNumber:0 }}</label></widget-value></td>
          <td colspan="8"><widget-value [align]="'right'" [color]="'white'"><label>{{currency}}{{ widgetData.uponCompletitionRoundedValueUponCompletionValueFromProjection2 | rdLocalizedNumber:0 }}</label></widget-value></td>
        </tr>
      </dynamic-growth-row>
    </tbody>

    <tbody>
      <dynamic-growth-row [row]="25" [widget]="this">
        <tr class="light-grey-line">
          <td colspan="14"><label>As Is</label></td>
          <td colspan="8"><widget-value [align]="'right'"><label>{{ widgetData.asIsAsIsValueFromProjection1 | rdLocalizedDate }}</label></widget-value></td>
          <td colspan="8"><widget-value [align]="'right'"><label>{{ widgetData.asIsAsIsValueFromProjection2 | rdLocalizedDate }}</label></widget-value></td>
        </tr>
      </dynamic-growth-row>

      <dynamic-growth-row [row]="26" [widget]="this">
        <tr>
          <td colspan="14"><label>Indicated Stabilized Value</label></td>
          <td colspan="8"><widget-value [align]="'right'"><label>{{ widgetData.asIsIndicatedStabilizedValueValueFromProjection1 | rdLocalizedNumber:0 }}</label></widget-value></td>
          <td colspan="8"><widget-value [align]="'right'"><label>{{ widgetData.asIsIndicatedStabilizedValueValueFromProjection2 | rdLocalizedNumber:0 }}</label></widget-value></td>
        </tr>
      </dynamic-growth-row>

      <ng-template *ngTemplateOutlet="adjustmentsTemplate; context: {area: 'asIs', rowindex: 27}"></ng-template>

      <dynamic-growth-row [row]="32" [widget]="this">
        <tr>
          <td colspan="14"><label>Total Adjustments</label></td>
          <td colspan="8"><widget-value [align]="'right'"><label>{{currency}}{{ widgetData.asIsTotalAdjustmentsValueFromProjection1 | rdLocalizedNumber:0 }}</label></widget-value></td>
          <td colspan="8"><widget-value [align]="'right'"><label>{{currency}}{{ widgetData.asIsTotalAdjustmentsValueFromProjection2 | rdLocalizedNumber:0 }}</label></widget-value></td>
        </tr>
      </dynamic-growth-row>

      <dynamic-growth-row [row]="33" [widget]="this">
        <tr class="light-grey-line">
          <td colspan="14"><label>Indicated Value upon Stabilization</label></td>
          <td colspan="8"><widget-value [align]="'right'"><label>{{currency}}{{ widgetData.asIsIndicatedAsIsValueValueFromProjection1 | rdLocalizedNumber:0 }}</label></widget-value></td>
          <td colspan="8"><widget-value [align]="'right'"><label>{{currency}}{{ widgetData.asIsIndicatedAsIsValueValueFromProjection2 | rdLocalizedNumber:0 }}</label></widget-value></td>
        </tr>
      </dynamic-growth-row>

      <dynamic-growth-row [row]="34" [widget]="this">
        <tr class="darkGreyTableHeader">
          <td colspan="14"><label style="color: white;">Rounded Value upon Stabilization</label></td>
          <td colspan="8"><widget-value [align]="'right'" [color]="'white'"><label>{{currency}}{{ widgetData.asIsRoundedAsIsValueValueFromProjection1 | rdLocalizedNumber:0 }}</label></widget-value></td>
          <td colspan="8"><widget-value [align]="'right'" [color]="'white'"><label>{{currency}}{{ widgetData.asIsRoundedAsIsValueValueFromProjection2 | rdLocalizedNumber:0 }}</label></widget-value></td>
        </tr>
      </dynamic-growth-row>
    </tbody>
  </table>
</div>

<ng-template #adjustmentsTemplate let-area="area" , let-rowindex="rowindex">

  <dynamic-growth-row [row]="rowindex" [widget]="this">
    <tr class="light-grey-line">
      <td colspan="30"><label>{{'directCapConclusion.labelAdjustments' | rdTranslate}}</label></td>
    </tr>
  </dynamic-growth-row>

  <ng-container *ngFor="let i of [1,2,3,4]">

    <dynamic-growth-row [row]="rowindex + i" [widget]="this">
      <tr [class.light-grey-line]="i%2 === 0">
        <td colspan="14"><widget-value [align]="'left'"><label>{{ widgetData[area + 'Adjustments' + i + 'Label'] }}</label></widget-value></td>
        <td colspan="8"><widget-value [align]="'right'"><label>{{currency}}{{ widgetData[area + 'Adjustments' + i + 'ValueFromProjection1'] | rdLocalizedNumber:0 }}</label></widget-value></td>
        <td colspan="8"><widget-value [align]="'right'"><label>{{currency}}{{ widgetData[area + 'Adjustments' + i + 'ValueFromProjection2'] | rdLocalizedNumber:0 }}</label></widget-value></td>
      </tr>
    </dynamic-growth-row>
  </ng-container>
</ng-template>
